import React from 'react';
import styled from 'styled-components';
import { staticUrl } from 'emerald-ui/dist/globals/urls';
import { gray0 } from 'emerald-ui/dist/globals/colors';
import { font } from 'emerald-ui/dist/globals/fonts';

export const Cancelled = ({ text }) => {
    return (
        <Cancelled_Root>
            <img
                alt='Cancelled Icon'
                src={staticUrl('tracking/cancelled.svg')}
            />
            {text}
        </Cancelled_Root>
    );
};

const Cancelled_Root = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-color: ${gray0};
    img {
        height: 4em;
        width: 4em;
        margin-bottom: 1em;
    }
    padding: 1em;
    font-family: ${font.medium};
    font-size: 1em;
`;
